import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { OrderResponseDto } from '@tiendanube/common';
import { RootStateType } from 'App/store';
import { getOrdersByIds } from '../../ordersSlice/ordersSelectors';

export function useGetOrdersByIds(ids: string[]): OrderResponseDto[] {
  const orders = useSelector((state: RootStateType) =>
    getOrdersByIds(state, ids),
  );

  const sortedOrders = useMemo(
    () => orders.sort((a, b) => b.number - a.number),
    [orders],
  );

  return sortedOrders;
}
